import moment from "moment/moment";
import _ from 'lodash';
import { connect } from "react-redux";
import Select from 'react-select';
import React, {Component, Fragment} from 'react';
import ViewHeader from '../view-header';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ModalComponent from "../../../../components/Modal";
import Notice from "../../../../components/Notification/newNotification";
import {
    editCase,
    getCase,
    cancelCase,
    getAvailableUnits,
    convertCase,
    editAdminCaseNotes,
    changeCaseStatus
} from "./actions";
import {
    startImageUploading,
    removeAllImageUploads
} from "../../../../shared/redux/actions"
import ViewForPrinting from '../../../../components/CaseDetails/ViewForPrinting'
import { Input, FormText } from 'reactstrap';
import Images from '../../../../components/Images/Images';
import HistoryWrapper from "../../../../components/History/wrapper";
import SubcaseForm from "../../../../components/SubCaseForm";
import {
    addBooking,
    addDentist,
    addPatient,
    getData,
    getCase as getCaseDetails,
    getParentCases,
    getVacationDaysRequest
} from "../dashboard/actions";
import { Redirect } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import {isNonWorkingDay} from "../../../../helpers";
import { processImageUpdate } from "./helpers";


//Icon
import IconSpinner from 'react-icons/lib/fa/spinner';

// Images
import SubcaseModalBody from "../../../../components/CreateSubcase";
import { globals } from "../../../../../../common/constants";
import {
    ADD_CASE_SUCCESS_MESSAGE,
    APPROVE_CASE_SUCCESS_MESSAGE,
    CONVERT_TO_CASE_SUCCESS_MESSAGE,
    CONVERT_TO_SUBCASE_SUCCESS_MESSAGE,
    DELETE_CASE_SUCCESS_MESSAGE,
    REJECT_CASE_SUCCESS_MESSAGE,
    UPDATE_CASE_SUCCESS_MESSAGE
} from "../../../../shared/constants";
import {getAvailableUnitsList} from "../AvailableUnits/actions";
import Spinner from "../../../../components/Spinner";
import {RouteLeavingGuard} from "../../../../components/RouteLeavingGuard";

class AdminCaseDetails extends Component {
  constructor(props) {
    super(props);
      this.bridgesRef = React.createRef();
      this.state = {
      parentBridges: [],
      parentCheckedTeeth:[],
      parentPrevCheckedTeeth: [],
      isDirty: false,
      showImages: false,
      fromCase: false,
      showAdminNotesBtn: false,
      tableOption: {
        noDataText: 'No case is available yet.',
        hideSizePerPage: true,
        sizePerPage: 10,
        onRowClick: (row) => this.linkToCase(row)
      },
      selectRowProp: {
        mode: 'radio',
        className: 'selectedItemInTable',
        hideSelectColumn: true,
        clickToSelect: true
      },
      implantsPartObject: {
        1: { name: 'Impression coping ', number: 0 },
        2: { name: 'Impression screw ', number: 0 },
        3: { name: 'Lab analog ', number: 0 },
        4: { name: 'Prosthetic screw ', number: 0 },
        5: { name: 'Abutment/Ti', number: 0 },
        6: { name: 'Other ', number: 0 }
      },
      enclosedBoxObject: {
        1: { name: 'Impression/master model' },
        2: { name: 'Antagonist model/impression' },
        3: { name: 'Bite' },
        4: { name: 'Pre-op/temp model/impression' },
        5: {name:  'Optical scan'},
        6: { name: 'Implant parts' },
        7: { name: 'Other ' }
      },
      validationBooking: {
        patientId: false,
        numberOfUnits: false,
        type: false,
        implant: false,
        sendingDate: false,
        enclosedBox: false,
        returnDate: false
      },
        bridgesStructure: {
            top: {
                left: {
                    '_13': {index: 5, number: 13}, '_14': {index: 4, number: 14}, '_15': {index: 3, number: 15}, '_16': {index: 2, number: 16}, '_17': {index: 1, number: 17}, '_18': {index: 0, number: 18},
                },
                center: {
                    '_12': {index: 6, number: 12}, '_11': {index: 7, number: 11}, '_21': {index: 8, number: 21}, '_22': {index: 9, number: 22},
                },
                right: {
                    '_23': {index: 10, number: 23}, '_24': {index: 11, number: 24}, '_25': {index: 12, number: 25}, '_26': {index: 13, number: 26}, '_27': {index: 14, number: 27}, '_28': {index: 15, number: 28},
                },
            },
            bottom: {
                left: {
                    '_48': {index: 0, number: 48}, '_47': {index: 1, number: 47}, '_46': {index: 2, number: 46}, '_45': {index: 3, number: 45}, '_44': {index: 4, number: 44}, '_43': {index: 5, number: 43},
                },
                center: {
                    '_42': {index: 6, number: 42}, '_41': {index: 7, number: 41}, '_31': {index: 8, number: 31}, '_32': {index: 9, number: 32},
                },
                right: {
                    '_38': {index: 15, number: 38}, '_37': {index: 14, number: 37}, '_36': {index: 13, number: 36}, '_35': {index: 12, number: 35}, '_34': {index: 11, number: 34}, '_33': {index: 10, number: 33},
                },
            }
        },
      redirect: false,
      currentNumberOfUnits: 0,
      after24Hour: false,
      dentistName: '',
      patientName: '',
      showEditModal: false,
      cancelCaseModal: false,
      modalBody: '',
      modalHeader: 'Request Change',
      availableUnits: 0,
      patient: {
        bookingId: 0,
        sendingDate: '',
        status: '',
        dateOfSubmission: '',
        dateOfReturn: '',
        patientId: '',
        numberOfUnits: '',
        type: '',
        notes: '',
        color: '',
        signature: '',
        license: '',
        implant: '',
        implantType: '',
        implantSize: '',
        enclosedBox: [],
        implantParts: {},
        images: [],
        admin_case_notes: '',
        isArchived: false,
        is_received: false,
        bridges:[],
      },
        checkedTeeth:[],
        prevCheckedTeeth: [],
        caseId: this.props.match.params.caseId,
      hasErrorImages: false,
      isOpenSubcaseForm: false,
      buttonDisabled: true,
      parentId: null,
      isOpenConvertModal: false,
      isOpenProceedModal: false,
        caseStatus: '',
        changeStatusModal: '',
        modalHeaderType: '',
        modalHeaderText: '',
        modalBodyText: '',
        showToaster: true
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.toggleSubcaseFormModal = this.toggleSubcaseFormModal.bind(this);
    this.linkToCasePage = this.linkToCasePage.bind(this);
    this.handleGoBack = this.handleGoBack.bind(this);
    this.cancelEdits = this.cancelEdits.bind(this);
  }

    componentDidMount() {
        document.title = "Case " + this.state.caseId;
        this.props.getVacationDays();
        this.props.getCase(this.state.caseId);
        this.props.getParentCases();
        if (this.props.location.state && this.props.location.state.showImages) {
            this.setState({ showImages: true })
        }
    }

    toggleSubcaseFormModal() {
        const isSubCaseOpened = this.state.isOpenSubcaseForm;
        this.setState((prevState) => ({
                isOpenSubcaseForm: !isSubCaseOpened,
                ...(isSubCaseOpened
                        ? {
                            bridges: prevState.parentBridges,
                            checkedTeeth: prevState.parentCheckedTeeth,
                            prevCheckedTeeth: prevState.parentPrevCheckedTeeth,
                        }
                        :
                        {
                            parentBridges: prevState.patient.bridges,
                            patient: {...prevState.patient, bridges: []},
                            checkedTeeth: [],
                            prevCheckedTeeth: [],
                            parentCheckedTeeth: prevState.checkedTeeth,
                            parentPrevCheckedTeeth: prevState.parentPrevCheckedTeeth
                        }
                ),
            })
        );
    }

    componentDidUpdate(prevProps) {
        const paramCaseId = this.props.match.params.caseId;
        if (String(this.state.caseId) !== paramCaseId) {
            this.props.getCase(paramCaseId);
            document.title = "Case " + paramCaseId;
            this.setState({ caseId: paramCaseId });
        }
    }

    get dentistList() {
        // can't edit dentist of cases with status 'pending'
        const isPendingCase = this.state.patient.status === globals.PATIENT.STATUS.PENDING;
        const caseDetails = this.props.adminCaseDetails.caseList.caseDetails;
        const dentistsList = this.props.adminCaseDetails.caseList.dentists;
        if (isPendingCase && caseDetails && dentistsList) {
            return dentistsList.filter(dentist => dentist.id === caseDetails.dentist_id.id);
        }
        return dentistsList || []
    }

    get currentDentist() {
        const caseDetails = this.props.adminCaseDetails.caseList.caseDetails;
        const dentistsList = this.props.adminCaseDetails.caseList.dentists;
        return dentistsList.find(dentist => dentist.id === caseDetails.dentist_id.id) || {};
    }
    handleClose(changeIsDirtyValue = true ) {
        this.setState({
            ...(changeIsDirtyValue && { isDirty: true }),
            showEditModal: false,
            cancelCaseModal: false,
            isOpenConvertModal: false,
            changeStatusModal: false,
            modalHeaderText: '',
            modalBodyText: '',
        });
    }

    cancelBooking() {
        if (!this.state.cancelCaseModal) {
            this.setState({ cancelCaseModal: true });
        } else {
            this.props.cancelCase(this.state.caseId)
        }
    }

    handleDateChange(date) {
        if (date) {
            this.setState({
                patient: {
                    ...this.state.patient,
                    dateOfReturn: moment(date).format('YYYY-MM-DD'),
                },
                buttonDisabled: false,
                isDirty: true,
            }, () => {
                this.props.getAvailableUnits({ date: moment(date).format('YYYY-MM-DD'), caseId: this.state.patient.bookingId });
            });
        } else {
            this.setState({
                patient: {
                    ...this.state.patient,
                    dateOfReturn: date
                },
                buttonDisabled: false
            });
        }
    }

    handleChangeSendingDate(sendingDate) {
        this.setState({
            patient: {
                ...this.state.patient,
                sendingDate: sendingDate ? moment(sendingDate).format('YYYY-MM-DD') : sendingDate
            },
            isDirty: true,
            buttonDisabled: false,
        });
    }

    handleChange(key, value, find = null, isDirty = true) {
        if (key === 'enclosedBox') {
            var enclosedBox = this.state.patient[key];
            const find = enclosedBox.find(item => { return item === value });
            const updateData = (find > 0) ? enclosedBox.filter(e => e !== value) : [...this.state.patient[key], value];
            this.setState({
                patient: { ...this.state.patient, [key]: updateData },
                buttonDisabled: false,
                isDirty: true,
            })
        } else if (key === 'implantParts') {
            let updateData, implantParts = this.state.patient[key];
            let buttonDisabled = false;
            if (implantParts[value] !== undefined && !find) {
                delete implantParts[value]
                updateData = implantParts;
            } else {
                updateData = { ...this.state.patient[key], [(find) ? find : value]: (find) ? value : 0 }
            }
            this.setState({
                patient: { ...this.state.patient, [key]: updateData },
                buttonDisabled,
                isDirty: true,
            })
        } else if (key === 'image') {
            const images = this.state.patient.images;
            if (value.hasError) {
                this.setState({ hasErrorImages: true });
            } else {
                this.setState({
                    loaderForImage:false,patient: { ...this.state.patient, images: [...images, ...value.currentImage] },
                    hasErrorImages: false,
                    buttonDisabled: false,
                    isDirty,
                })
            }
        }
        else if (key === 'admin_case_notes') {
            this.setState({
                ...this.state,
                showAdminNotesBtn: true,
                buttonDisabled: false,
                isDirty:true,patient: {
                    ...this.state.patient,
                    [key]: value
                }
            })
        }
        else {
            this.setState({
                patient: {
                    ...this.state.patient,
                    [key]: value
                },
                buttonDisabled: false,
                isDirty: true,
            })
        }
    }


    changeStatusIfRequired = () => {
        const id = this.props.location.state && this.props.location.state.id
        const status = this.props.location.state && this.props.location.state.status
        if (id && status) {
            this.props.changeCaseStatus({ id, status })
        }
    }

    async editCaseRequest(callBack) {
        const locationStatus = this.props.location.state && this.props.location.state.status;
        await processImageUpdate(this.state, this.bridgesRef.current);

        this.props.editCase({
            patient: {
                ...this.state.patient,
                images: this.state.patient.images.map(({filename}) => ({filename})),
                status: locationStatus ? locationStatus : this.state.patient.status
            },
            callBack: callBack
        });
        this.setState({showEditModal: false})
    }

    makeBridge = (from,to) => {
        this.setState({isDirty:true,buttonDisabled:false})
        const bridges = this.state.patient.bridges;
        const checkedTeeth = this.state.checkedTeeth;
        if(from === to) {
            if(bridges.length){
                if(checkedTeeth.includes(from) && checkedTeeth.includes(to)){
                    const filteredBridge = bridges.filter((bridge)=> {
                        return bridge.from !== from
                    })
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        patient:{...this.state.patient,bridges:filteredBridge}
                    })
                } else {
                    bridges.push({from:from, to:to})
                    checkedTeeth.push(from);
                    this.setState({
                        checkedTeeth:checkedTeeth,
                        patient:{...this.state.patient,bridges:bridges}
                    })
                }
            }else {
                checkedTeeth.push(to);
                bridges.push({from:from,to:to})
                this.setState({
                    checkedTeeth:checkedTeeth,
                    patient:{...this.state.patient,bridges:bridges}
                })
            }

        } else {
            if(checkedTeeth.includes(from) && checkedTeeth.includes(to) && from !== 11 && from !== 41){
                let isBridged = false;
                const filteredBridges = bridges.filter(bridge => {
                    if (bridge.from === from && bridge.to === to) {
                        isBridged = true;
                        return false;
                    }
                    return bridge.from !== from && bridge.to !== to;
                })
                if(isBridged){
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from && teeth !== to;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        patient:{
                            ...this.state.patient,
                            bridges: filteredBridges
                        }
                    })
                } else {
                    bridges.push({from:from,to:to});
                    this.setState({
                        patient:{...this.state.patient,bridges:bridges}
                    })
                }
            } else {
                if(from === 11){
                    let isBridged = false;
                    if(checkedTeeth.includes(from) && checkedTeeth.includes(21)){
                        const filteredBridges = bridges.filter(bridge => {
                            if (bridge.from === from && bridge.to === 21) {
                                isBridged = true;
                                return false;
                            }
                            return bridge.from !== from && bridge.to !== 21;
                        })
                        if(isBridged){
                            const filteredTeeth = checkedTeeth.filter((teeth)=>{
                                return teeth !== from && teeth !== 21;
                            })
                            this.setState({
                                checkedTeeth:filteredTeeth,
                                patient:{
                                    ...this.state.patient,
                                    bridges: filteredBridges
                                }
                            })
                        } else {
                            bridges.push({from:from, to:21});
                            checkedTeeth.push(from,21);
                            this.setState({
                                checkedTeeth:checkedTeeth,
                                patient:{...this.state.patient,bridges:bridges}
                            })
                        }
                    }else {
                        bridges.push({from:from, to:21});
                        checkedTeeth.push(from,21);
                        this.setState({
                            checkedTeeth:checkedTeeth,
                            patient:{...this.state.patient,bridges:bridges}
                        })
                    }
                } else if(from === 41){
                    let isBridged = false;
                    if(checkedTeeth.includes(from) && checkedTeeth.includes(31)){
                        const filteredBridges = bridges.filter(bridge => {
                            if (bridge.from === from && bridge.to === 31) {
                                isBridged = true;
                                return false;
                            }
                            return bridge.from !== from && bridge.to !== 31;
                        })
                        if(isBridged){
                            const filteredTeeth = checkedTeeth.filter((teeth)=>{
                                return teeth !== from && teeth !== 31;
                            })
                            this.setState({
                                checkedTeeth:filteredTeeth,
                                patient:{
                                    ...this.state.patient,
                                    bridges: filteredBridges
                                }
                            })
                        } else {
                            bridges.push({from:from, to:31});
                            checkedTeeth.push(from,31);
                            this.setState({
                                checkedTeeth:checkedTeeth,
                                patient:{...this.state.patient,bridges:bridges}
                            })
                        }
                    }else {
                        bridges.push({from:from, to:31});
                        checkedTeeth.push(from,31);
                        this.setState({
                            checkedTeeth:checkedTeeth,
                            patient:{...this.state.patient,bridges:bridges}
                        })
                    }

                } else {
                    bridges.push({from: from, to: to});
                    checkedTeeth.push(from, to);
                    this.setState({
                        checkedTeeth: checkedTeeth,
                        patient: {...this.state.patient, bridges: bridges}
                    })
                }
            }
        }
    }

    async handleSaveBooking(event, showConfirmationModal = true) {

        const {patient} = this.state;
        const {
            BOOKING_TYPES: {PROTOTYPE, ZIRCONIA, CERAMIC, OTHER, TEMP},
            PATIENT: {
                STATUS: {OVERDUE, SCHEDULED, PENDING, RECEIVED}
            },
        } = globals;

        const bookingInfo = patient;
        const patientId = bookingInfo.patientId <= 0;
        const numberOfUnits = bookingInfo.numberOfUnits <= 0;
        const implant = !(bookingInfo.implant === '1' || bookingInfo.implant === '0');
        const sendingDate = !bookingInfo.sendingDate;
        const returnDate = !bookingInfo.dateOfReturn;
        const enclosedBox = !bookingInfo.enclosedBox.length;
        const referenceDay = moment();
        const today = referenceDay.clone().startOf('day');
        const type = !(bookingInfo.type === PROTOTYPE
            || bookingInfo.type === ZIRCONIA
            || bookingInfo.type === TEMP
            || bookingInfo.type === OTHER
            || bookingInfo.type === CERAMIC);

        if (patientId || numberOfUnits || type || implant || sendingDate || enclosedBox || returnDate) {
            this.setState({
                validationBooking: {
                    patientId,
                    sendingDate,
                    numberOfUnits,
                    type,
                    implant,
                    enclosedBox,
                    returnDate,
                }
            });
        } else {
            event.preventDefault();
            if (!showConfirmationModal) {
                this.editCaseRequest(this.changeStatusIfRequired);
                this.setState({ isDirty: false });
                return;
            }
            const editModalData = {
                isDirty: false,
                showEditModal: true,
                modalHeader: "Edit Case",
                modalBody: "Are you sure you want to confirm the changes?"
            }
            if (moment(bookingInfo.dateOfReturn) < moment(bookingInfo.sendingDate)) {
                Notice.addNotification('Sending Date should not be late than Return Date.', 'error');
            } else if (!this.state.showEditModal && patient.status === PENDING) {
                this.setState({
                    showEditModal: true,
                    modalHeader: "Confirm Booking",
                    modalBody: "Are you sure you want to confirm the booking request?",
                });
            } else if (!this.state.showEditModal && patient.status === OVERDUE) {
                if (moment(patient.dateOfReturn).isAfter(referenceDay)) {
                    const { is_received } =  this.props.adminCaseDetails.caseList.caseDetails;
                    this.setState({
                        patient: {
                            ...patient,
                            status: is_received ? RECEIVED : SCHEDULED,
                        },
                        ...editModalData,
                    })
                } else if (moment(patient.dateOfReturn).isBefore(today) || moment(patient.dateOfReturn).isSame(today, 'd')) {
                    this.setState({
                        ...this.state,
                        ...editModalData,
                    })
                }
            } else {
                if (this.state.showEditModal === true) {
                    this.editCaseRequest(this.changeStatusIfRequired);
                } else {
                    this.setState({
                        showEditModal: true,
                        modalHeader: "Edit Case",
                        isDirty: false,
                        modalBody: "Are you sure you want to confirm the changes?"
                    });
                }
            }
        }
    }

    getDentistNameById(patientId, dentistList) {
        dentistList = (dentistList !== undefined) ? dentistList : this.dentistList
        const dentist = dentistList.find(dentist => {
            const dentistId = dentist.patients.find(item => {
                return patientId === item.id
            })
            if (dentistId !== undefined) {
                return dentistId.dentist_id === dentist.id
            } else {
                return false
            }
        })
        if (dentist !== undefined) return dentist.first_name + ' ' + dentist.last_name
    }

    getPatientNameByDentistId(patientId, dentistList) {
        dentistList = (dentistList !== undefined) ? dentistList : this.dentistList
        var patientName;
        dentistList.find(dentist => {
            return dentist.patients.find(item => {
                patientName = item.first_name + ' ' + item.last_name
                return patientId === item.id
            })
        })
        if (patientName !== undefined) return patientName
    }

    shouldComponentUpdate(nextProps, nextState) {
        const adminCaseDetails = this.props.adminCaseDetails.caseList.caseDetails;
        if (adminCaseDetails && !_.isEqual(this.state, nextState)) {
            const dentistName = this.getDentistNameById(adminCaseDetails.patient.id, this.props.adminCaseDetails.caseList.dentists);
            const patientName = this.getPatientNameByDentistId(adminCaseDetails.patient.id, this.props.adminCaseDetails.caseList.dentists);
            const details = {
                prevStatus: adminCaseDetails.prevStatus,
                bookingId: adminCaseDetails.id,
                sendingDate: moment(adminCaseDetails.sending_date).format('YYYY-MM-DD'),
                status: adminCaseDetails.status,
                dateOfSubmission: adminCaseDetails.date_of_submission,
                dateOfReturn: moment(adminCaseDetails.date_of_return).format('YYYY-MM-DD'),
                patientId: adminCaseDetails.patient.id,
                numberOfUnits: adminCaseDetails.number_of_units.toString(),
                type: adminCaseDetails.type,
                notes: adminCaseDetails.notes,
                color: adminCaseDetails.color,
                signature: adminCaseDetails.signature,
                license: adminCaseDetails.license,
                implant: adminCaseDetails.implant.toString(),
                implantType: adminCaseDetails.implant_type,
                implantSize: adminCaseDetails.implant_size,
                enclosedBox: this.props.adminCaseDetails.caseList.enclosedBox,
                implantParts: this.props.adminCaseDetails.caseList.implantParts,
                images: this.props.adminCaseDetails.caseList.images,
                bridges:this.props.adminCaseDetails.caseList.bridges
            };

            if (_.isEqual(details, nextState.patient) && _.isEqual(nextState.dentistName, dentistName) && _.isEqual(nextState.patientName, patientName)) {
                this.setState({ buttonDisabled: true });
            }
        }
        return true
    }

    componentWillUnmount() {
        if (this.props.location.state) {
            delete this.props.location.state.id;
        }
        this.props.removeAllUploads();
    }

    componentWillReceiveProps(nextProps) {
        const locationState = this.props.location.state;
        if (nextProps.adminCaseDetails.cancelCase && !this.props.adminCaseDetails.cancelCase) {
            Notice.addNotification('Booking is successfully canceled.', 'success');

            if (locationState) {
                this.props.history.push({
                    pathname: locationState.previous ? locationState.previous.page : locationState.page,
                    state: {
                        defaultDate: locationState.previous ? locationState.previous.defaultDate : new Date(this.state.patient.dateOfReturn),
                        filterData: locationState.previous ? locationState.previous.filterData : locationState.filterData,
                        pageNumber: locationState.previous ? locationState.previous.filterData : locationState.pageNumber,
                        page: locationState.previous ? locationState.previous.page : locationState.page,
                    }
                });
            } else {
                this.setState({ redirect: true });
            }
        } else if (nextProps.adminCaseDetails.caseFaller === true) {
            Notice.addNotification('Case is not found.', 'error');
            this.setState({ redirect: true });
        }
        if (!nextProps.adminCaseDetails.isStatusChanging && this.props.adminCaseDetails.isStatusChanging) {
            if (nextProps.adminCaseDetails.getCasesSuccess) {
                if (this.state.showToaster) {
                    let message = UPDATE_CASE_SUCCESS_MESSAGE;
                    switch (this.state.caseStatus) {
                        case "cancel":
                            message = DELETE_CASE_SUCCESS_MESSAGE;
                            break;
                        case 'rejected':
                            message = REJECT_CASE_SUCCESS_MESSAGE;
                            break;
                        case "approved":
                            message = APPROVE_CASE_SUCCESS_MESSAGE;
                            break;
                    }
                    Notice.addNotification(message, 'success');
                } else {
                    this.setState({showToaster: true});
                }
                this.setState({changeStatusModal: false, caseStatus: ''});
            } else {
                Notice.addNotification('Something went wrong.', 'error');
                this.setState({changeStatusModal: false});
            }
        }

    if (nextProps.adminCaseDetails.loading === false && !nextProps.adminCaseDetails.caseFaller) {
      if (nextProps.adminCaseDetails.edited === true && !this.props.adminCaseDetails.edited) {
        const caseId = this.state.caseId;
        Notice.addNotification('Case is successfully edited.', 'success');
        this.setState({ buttonDisabled: false, validationBooking: { patientId: false, numberOfUnits: false, type: false, implant: false, sendingDate: false, enclosedBox: false, returnDate: false } })
        this.props.startImageUploading({caseId,isAdmin: true});
      } else if (nextProps.adminCaseDetails.editFailer === true) {
        Notice.addNotification('Something went wrong.', 'error');
      } else if (nextProps.adminCaseDetails.converted && !this.props.adminCaseDetails.converted) {
        Notice.addNotification(this.state.patient.parentId ? CONVERT_TO_CASE_SUCCESS_MESSAGE : CONVERT_TO_SUBCASE_SUCCESS_MESSAGE, 'success');
        this.setState({ isOpenConvertModal: false, parentId: null });
        this.props.getCase(this.state.caseId);
      }
      const adminCaseDetails = nextProps.adminCaseDetails.caseList.caseDetails;
      if(nextProps.adminCaseDetails.availableUnits) {
        this.setState({
          availableUnits: nextProps.adminCaseDetails.availableUnits
        });
      }
      if (adminCaseDetails !== undefined && nextProps.adminCaseDetails.getCasesSuccess && !this.props.adminCaseDetails.getCasesSuccess) {
        const dateOfSubmission = moment(adminCaseDetails.date_of_submission);
        const dateNow = moment();
        const diff = dateNow.diff(dateOfSubmission, 'hours');
        var after24Hour = (diff > 24) ? true : false;
        const dentistName = this.getDentistNameById(adminCaseDetails.patient.id, nextProps.adminCaseDetails.caseList.dentists);
        const patientName = this.getPatientNameByDentistId(adminCaseDetails.patient.id, nextProps.adminCaseDetails.caseList.dentists);

          const adminCaseDetailsPatient = {
              prevStatus: adminCaseDetails.prevStatus,
              bookingId: adminCaseDetails.id,
              sendingDate: moment(adminCaseDetails.sending_date).format('YYYY-MM-DD'),
              status: adminCaseDetails.status,
              dateOfSubmission: adminCaseDetails.date_of_submission,
              dateOfReturn: moment((nextProps.adminCaseDetails.dateOfReturn !== undefined) ? nextProps.adminCaseDetails.dateOfReturn : adminCaseDetails.date_of_return).format('YYYY-MM-DD'),
              patientId: adminCaseDetails.patient.id,
              numberOfUnits: adminCaseDetails.number_of_units.toString(),
              type: adminCaseDetails.type,
              notes: adminCaseDetails.notes,
              admin_case_notes: adminCaseDetails.admin_case_notes,
              color: adminCaseDetails.color,
              signature: adminCaseDetails.signature,
              license: adminCaseDetails.license,
              implant: adminCaseDetails.implant.toString(),
              implantType: adminCaseDetails.implant_type,
              implantSize: adminCaseDetails.implant_size,
              enclosedBox: nextProps.adminCaseDetails.caseList.enclosedBox,
              implantParts: nextProps.adminCaseDetails.caseList.implantParts,
              images: nextProps.adminCaseDetails.caseList.images,
              is_received: adminCaseDetails.is_received,
              isArchived: adminCaseDetails.isArchived,
              parentId: adminCaseDetails.parent_id,
              bridges: nextProps.bridges,
          }

        this.setState({
          after24Hour: after24Hour,
          availableUnits: (nextProps.adminCaseDetails.availableUnits !== undefined) ? nextProps.adminCaseDetails.availableUnits : nextProps.adminCaseDetails.caseList.avaliableUnits,
          currentNumberOfUnits: (nextProps.adminCaseDetails.myUnits !== undefined) ? nextProps.adminCaseDetails.myUnits : adminCaseDetails.number_of_units,
          dentistName: dentistName,
          patientName: patientName,
          parentId: adminCaseDetails.parent_id,
          patient: this.props.adminCaseDetails.isStatusChanging ? { ...this.state.patient, status: adminCaseDetailsPatient.status } : adminCaseDetailsPatient,
          validationBooking: { patientId: false, numberOfUnits: false, type: false, implant: false, sendingDate: false, enclosedBox: false, returnDate: false }
        })
      }
        if (!this.props.adminCaseDetails.isStatusChanging) {
            const checkTeeths = [];
            nextProps.bridges && nextProps.bridges.forEach((item)=>{
                if(item.from !== item.to){
                    if(!this.state.checkedTeeth.includes(item.from)){
                        checkTeeths.push(item.from);
                    }
                    if(!this.state.checkedTeeth.includes(item.to)){
                        checkTeeths.push(item.to);
                    }
                }else{
                    checkTeeths.push(item.to);
                }
            })

                this.setState({
                    checkedTeeth:checkTeeths,
                    prevCheckedTeeth: [...checkTeeths]
                })
            }
        }

        if (nextProps.adminDashboard.addIsSuccess === true && !this.props.adminDashboard.addIsSuccess) {
            this.setState({
                dentist: { ...this.state.dentist, value: nextProps.adminDashboard.dentistInfo.id },
                dentistName: this.state.dentist ? this.state.dentist.label : '',
                validationBooking: {
                    ...this.state.validationBooking,
                    dentist_name: false,
                    dentistSelected: false
                }
            });
            Notice.addNotification('Dentist is successfully added.', 'success');
        } else if (nextProps.adminDashboard.addIsSuccess === false) {
            Notice.addNotification('Something went wrong.', 'error');
        }

        if (nextProps.adminDashboard.patientAdded === true && !this.props.adminDashboard.patientAdded) {
            this.setState({
                data: {
                    ...this.state.data,
                    patient_id: this.state.patient ? nextProps.adminDashboard.patientInfo.id : 0
                },
                validationBooking: {
                    ...this.state.validationBooking,
                    patient_name: false,
                    dentistSelected: false
                }
            });
            Notice.addNotification('Patient is successfully added.', 'success');
        } else if (nextProps.adminDashboard.patientAdded === false) {
            Notice.addNotification('Something went wrong.', 'error');
        }

        if (this.props.imageUpload.uploadingComplete && !this.props.imageUpload.uploadingImages && !this.props.imageUpload.hasErrors && this.state.isOpenSubcaseForm) {
            this.setState({ printModal: true, isOpenSubcaseForm: false });
        }

        if (nextProps.adminDashboard.added === true && !this.props.adminDashboard.added) {
            Notice.addNotification(ADD_CASE_SUCCESS_MESSAGE, 'success');
            this.props.startImageUploading({caseId: nextProps.adminDashboard.addedData,isAdmin: true});
        } else if (nextProps.adminDashboard.added === false && this.props.adminDashboard.added) {
            Notice.addNotification('Your session is expired.', 'error');
        }
        if (!nextProps.adminCaseDetails.isStatusChanging && this.props.adminCaseDetails.isStatusChanging) {
            this.handleClose(false);
        }
    }

    handleSeeMore() {
        this.setState({ showImages: true, fromCase: true });
    }

    handleGoBack() {
        const locationState = this.props.location.state;
        if (this.state.fromCase) {
            this.setState({ showImages: false, fromCase: false })
        } else {
            if (locationState) {
                const page = locationState.previous ? locationState.previous.page : locationState.page;
                this.props.history.push({
                    pathname: locationState.page,
                    state: {
                        defaultDate: locationState.previous ? locationState.previous.defaultDate : new Date(this.state.patient.dateOfReturn),
                        filterData: locationState.previous ? locationState.previous.filterData : locationState.filterData,
                        pageNumber: locationState.previous ? locationState.previous.pageNumber : locationState.pageNumber,
                        page: page,
                    }
                });
            } else {
                this.props.history.push('/sm-admin/cases');
            }
        }
    }

    removeImage(name) {
        const filteredImages = this.state.patient.images.filter(image => image.filename !== name);
        const isImageRemoved = !_.isEqual(filteredImages, this.props.adminCaseDetails.caseList.images);
        this.setState({ patient: {
                ...this.state.patient,
                images: filteredImages
            },
            buttonDisabled: !isImageRemoved,
            isDirty: isImageRemoved
        });
    }

    getReceiveButton = (isReceived = false, cell) => {
        if (isReceived) {
            return (
                <button data-tip="Not Received" data-for="not-received" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, 'scheduled')}>
                    <span className="kr kr-close" />
                    <ReactTooltip place="top" id="not-received" type="light" effect="float" />
                </button>
            )
        } else {
            return (
                <button data-tip="Received" data-for="received" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, 'received')}>
                    <span className="kr kr-check" />
                    <ReactTooltip place="top" id="received" type="light" effect="float" />
                </button>
            )
        }
    };

    onChangeStatus(event, status, onhold) {
        let cell = this.state.patient;
        const { bookingId } = cell;
        const id = bookingId;

        const {changeStatusModal} = this.state;
        const {PATIENT: {STATUS: {REJECTED, SCHEDULED, CANCEL, RECEIVED, READY, ON_HOLD}}} = globals;
        const { BOOKING_TYPES: {ZIRCONIA, CERAMIC} } = globals;
        const {changeCaseStatus} = this.props;
        // do not show during change status to onhold
        if (status === ON_HOLD) {
            this.setState({ showToaster: false });
        }
        if (onhold) {
            const caseList = this.props.adminCaseDetails.caseList;
            const typeKey = [ZIRCONIA, CERAMIC].includes(caseList.caseDetails.type) ? 'zirconia' : 'misc';
            if (caseList.caseDetails.number_of_units > caseList.avaliableUnits[typeKey] && !changeStatusModal) {
                return this.setState({
                    caseId: id,
                    caseStatus: status,
                    changeStatusModal: true,
                    modalHeaderType: 'modalHeaderDefault',
                    modalHeaderText: 'Remove from On hold',
                    modalBodyText: 'Number of available units is expired. \n Are you sure you still want to add this case or you would like to reschedule?',
                });
            }
        }
        if (changeStatusModal) {
            const isCurrentStatusPending = cell && cell.status === "pending";
            const isApproved = status === SCHEDULED && isCurrentStatusPending;
            this.setState({
                caseStatus: isApproved ? 'approved' : status,
            });
            changeCaseStatus({id, status});
        } else {
            let modalHeaderType = 'modalHeaderSuccess';
            let defaultHeader = 'Revert from Ready';
            let defaultBody = 'Are you sure you want to revert case from Ready?';
            if (cell.status !== 'Ready') {
                if (onhold) {
                    modalHeaderType = 'modalHeaderSuccess';
                    defaultHeader = 'Remove from On hold';
                    defaultBody = 'Are you sure you want to revert remove case from on hold?';
                }
                switch (status) {
                    case REJECTED:
                        modalHeaderType = 'modalHeader';
                        defaultHeader = 'Reject Case';
                        defaultBody = 'Are you sure you want to reject the case?';
                        break;
                    case SCHEDULED:
                        if (cell.is_received) {
                            defaultHeader = 'Mark as Not Received';
                            defaultBody = 'Are you sure you want to mark this case as Not Received?';
                        } else {
                            defaultHeader = 'Confirm Case';
                            defaultBody = 'Are you sure you want to confirm the booking request?';
                        }
                        break;
                    case RECEIVED:
                        defaultHeader = 'Receive Case';
                        defaultBody = 'Are you sure the case is received?';
                        break;
                    case "onhold":
                        modalHeaderType = 'modalHeaderSuccess';
                        defaultHeader = 'On hold Case';
                        defaultBody = 'Are you sure you want to hold this case?';
                        break;
                    case CANCEL:
                        modalHeaderType = 'modalHeader';
                        defaultHeader = 'Delete Case';
                        defaultBody = 'Are you sure you want to delete the case?';
                        break;
                    case READY:
                        modalHeaderType = 'modalHeaderSuccess';
                        defaultHeader = 'Ready Case';
                        defaultBody = 'Are you sure you want to change the booking status to ready?';
                        break;
                }
            }
            this.setState({
                changeStatusModal: true,
                caseId: id,
                caseStatus: status,
                modalHeaderText: defaultHeader,
                modalBodyText: defaultBody,
                modalHeaderType: modalHeaderType
            })
        }
        event.stopPropagation();
    }

    actionFormatter = () => {
        let cell = this.state.patient;
        const dataTip = cell.parentId ? "Convert to Case" : "Convert to Subcase";
        const actionForConvert =
            <button data-tip={dataTip} data-for="convert" className="btn case-action-btn" onClick={(e) => this.convertCase(cell.id, e)}>
                <span className="kr kr-subcase" />
            </button>;
        switch (cell.status) {
            case 'pending': {
                return (
                    <div>
                        <button data-tip="Approve" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, 'scheduled', false, cell)}>
                            <span className="kr kr-check" />
                        </button>
                        <button data-tip="Reject" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, 'rejected')}>
                            <span className="kr kr-close" />
                        </button>
                        {actionForConvert}
                        <ReactTooltip place="top" type="light" effect="float"/>
                        <ReactTooltip place="top" id="convert" type="light" effect="float"/>
                    </div>
                );
            }
            case 'scheduled': {
                return (
                    <div>
                        <button data-tip="Received" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, 'received')}>
                            <span className="kr kr-check" />
                        </button>
                        {actionForConvert}
                        <ReactTooltip place="top" id="convert" type="light" effect="float"/>
                        <ReactTooltip place="top" type="light" effect="float"/>
                    </div>
                );
            }
            case 'onhold': {
                return (
                    <div>
                        {cell.status !== 'onhold' ?
                            <button data-tip='Remove from On hold' data-for="convert" className="btn case-action-btn"
                                    onClick={(event) => this.onChangeStatus(event, 'onhold')}>
                                <span className="kr kr-on-hold" />
                            </button> :
                            <button data-tip='Remove from On hold' data-for="rv" className="btn case-action-btn"
                                    onClick={(event) => this.onChangeStatus(event, cell.prevStatus, true, cell)}>
                                <span className="kr kr-unhold" />
                            </button>}
                        <ReactTooltip place="top" id="convert" type="light"  />
                        <ReactTooltip place="top" id="rv" type="light"  />
                    </div>
                );
            }
            case 'ready': {
                return (
                    <div>
                        <button
                            data-tip="Revert status"
                            className="btn case-action-btn"
                            onClick={(event) => this.onChangeStatus(event, cell.prevStatus, false)}>
                            <span className="kr kr-unhold" />
                        </button>
                        {actionForConvert}
                        <ReactTooltip place="top" id="convert" type="light" effect="float" />
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                );
            }
            case 'received': {
                return (
                    <div>
                        {this.getReceiveButton(true, cell)}
                        <button data-tip="Ready" data-for="ready" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, 'ready')}>
                            <span className="kr kr-ready" />
                        </button>
                        <button data-tip="Move to On hold" data-for="move" className="btn case-action-btn"
                                onClick={(event) => this.onChangeStatus(event, 'onhold')}>
                            <span className="kr kr-on-hold" />
                        </button>
                        {actionForConvert}
                        <ReactTooltip place="top" id="ready" type="light" effect="float" />
                        <ReactTooltip place="top" id="move" type="light" effect="float" />
                    </div>
                );
            }
            case 'overdue': {
                return (
                    <div>
                        {this.getReceiveButton(cell.is_received, cell)}
                        {(cell.prevStatus === 'received' || cell.is_received) && (<Fragment>
                            <button data-tip="Ready" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, 'ready')}>
                                <span className="kr kr-ready" />
                            </button>

                            <button data-tip="Move to On hold" data-for="mv" className="btn case-action-btn"
                                    onClick={(event) => this.onChangeStatus(event, 'onhold')}>
                                <span className="kr kr-on-hold"/>
                            </button>
                        </Fragment>)}
                        {actionForConvert}
                        <ReactTooltip place="top" id="convert" type="light" effect="float" />
                        <ReactTooltip place="top" id="mv" type="light" effect="float" />
                    </div>
                );
            }
            default: { break; }
        }
    }

    togglePrintModal = () => {
        this.props.getCase(this.state.caseId);
        this.setState({ printModal: !this.state.printModal, isOpenSubcaseForm: false });
    };

    toggleSubcasesTable() {
        this.setState({ isCasesTableOpen: !this.state.isCasesTableOpen });
    };

    linkToCasePage(row) {
        this.props.history.push({
            pathname: '/sm-admin/case-details/' + row.id,
            state: { page: '/sm-admin/case-details/' + row.parent_id, pageName: 'Case Details', previous: { ...this.props.location.state, page: this.props.location.state ? this.props.location.state.page : '', defaultDate: new Date(this.state.patient.dateOfReturn) } }
        });
    }

    convertCase() {
        if (this.state.isOpenConvertModal ) {
            const  isSubCase = !!this.props.adminCaseDetails.caseList.caseDetails.parent_id;
            const { bookingId: caseId, parentId } = this.state.patient;
            const selectedParentId = this.state.parentId;
            if (!this.props.adminCaseDetails.caseList.caseDetails.parent_id && !selectedParentId) {
                Notice.addNotification('Please select a Case ID.', 'error');
            }  else {
                this.props.convertCase(isSubCase ? { caseId } : { caseId, parentId: selectedParentId });
                this.setState({ isOpenConvertModal:  false });
            }
        } else {
            this.setState({
                isOpenConvertModal: true
            });
        }
    }

    handleChangeParentId = (item) => {
        this.setState({ parentId: item ? item.value : item });
    };

    get eventList() {
        return this.props.adminDashboard.parentCases;
    }
    cancelEdits() {
        this.setState({
            isDirty: false
        }, this.handleGoBack)
    }

    getGoBackButtonProps() {
        const { state } =  this.props.location;
        const isTherePageName = this.props.location.state && this.props.location.state.pageName;

        return {
            showBackIcon: true,
            history: this.props.history,
            title: `Go Back to ${ isTherePageName ? state.pageName : 'Cases' }`,
            goBackHandler: this.handleGoBack
        }
    }

    render() {
        const isSubCase = !!this.state.patient.parentId;
        const {redirect, patient} = this.state;
        const {
            PATIENT: {
                STATUS: {OVERDUE, SCHEDULED, PENDING, RECEIVED, REJECTED, READY, ON_HOLD}
            },
        } = globals;

        if (redirect) {
            return <Redirect to="/sm-admin/cases"/>
        }

        const disabled = patient.status === READY || patient.isArchived;
        const disabledOnhold = this.state.patient.status === ON_HOLD
        const scheduled = patient.status === SCHEDULED;
        const pending = patient.status === PENDING;
        const received = patient.status === RECEIVED;
        const overdue = patient.status === OVERDUE;
        const rejected = patient.status === REJECTED;
        const inputClassname = disabled ? 'desabledInput' : '';
        const receivedClassname = received ? 'desabledInput' : '';
        const isSignatureAndLicenseDisabled = disabled || disabledOnhold || pending || overdue || received || rejected || scheduled;
        const isSendingDateDisabled = (!this.state.patient.dateOfReturn && !this.state.patient.sendingDate) || disabled || received  || disabledOnhold || overdue;
        const sendingDateClassname = (!patient.dateOfReturn && !patient.sendingDate || disabled || received || overdue) ? 'desabledInput' : '';
        const readyDisabled = disabled ? 'desabledInput' : '';
        const disabledOverReject = overdue || rejected ? 'desabledInput' : '';

        const header = `Case ${this.state.caseId}`;
        const desc = `Details for ${this.state.caseId} case`;
        const checkedTeeth = this.state.checkedTeeth
        return (
            <div className="view">
                {(!this.props.adminCaseDetails.caseList.caseDetails || this.props.adminCaseDetails.isStatusChanging) ? <Spinner/> :
                    <Fragment>
                        <ViewHeader
                            saveDisabled={this.state.isDirty && this.state.patient.status === 'pending' ? false : this.state.buttonDisabled || this.props.adminCaseDetails.editingDataLoading}
                            header={header}
                            {...this.getGoBackButtonProps()}
                            desc={desc}
                            disabled={this.state.patient.isArchived}
                            primaryButtonName={'Convert to Subcase'}
                            secondaryButtonName={'Create Subcase'}
                            showPrint={true}
                            showSaveButton={true}
                            showPrimary={false}
                            showDelete={true}
                            showSecondary={true}
                            disabled={isSubCase}
                            handleSave={(event) => this.handleSaveBooking(event)}
                            openConvertModal={()=>this.convertCase()}
                            openModal={()=>this.toggleSubcaseFormModal()}
                            openPrintModal={()=>this.togglePrintModal()}
                            printRef={() => this.componentRef}
                            changeStatusButtons={true}
                            buttonsFunctionality={!patient.isArchived && this.actionFormatter()}
                            handleDelete={() => this.cancelBooking()}
                            status={this.state.patient.isArchived ? 'Archived' : this.state.patient.status}
                        />
                        { () => this.actionFormatter()}
                        <div className="view-content view-dashboard">
                            <div className="details">
                                <div className="details__container">
                                    {this.state.showImages && <Images images={this.state.patient.images}
                                                                      buttonDisabled={patient.isArchived}
                                                                      onImageChange={() => this.setState({ isDirty: true, buttonDisabled: false })}
                                                                      disabledEdit={patient.isArchived}
                                                                      handleSaveBooking={(event) => this.handleSaveBooking(event)}
                                                                      handleChange={(event, type) => this.handleChange(event, type)}
                                                                      removeImage={(filename) => this.removeImage(filename)}
                                                                      dentistId={this.props.adminCaseDetails.caseList.dentistId}
                                                                      caseId={this.state.caseId}
                                                                      isForm={false}
                                                                      status={this.state.patient.status}
                                                                      className="save-photos-block"
                                    />}
                                    {!this.state.showImages && <div className="case-details">
                                        {
                                            (this.props.adminCaseDetails.editingDataLoading === true) ?
                                                <h2 className="marginTopLoading"><IconSpinner className="spinner"/> Loading...</h2>
                                                :
                                                <form>
                                                    <div className="book">
                                                        <div className="book__block">
                                                            {
                                                                this.state.isOpenSubcaseForm ?
                                                                    <SubcaseForm
                                                                        caseDetails={this.props.adminCaseDetails.caseList.caseDetails}
                                                                        parent_id={this.state.caseId}
                                                                        isAdmin={true}
                                                                        dashboard={{...this.props.adminDashboard, patientList: this.currentDentist.patients}}
                                                                        saveDisabled={this.props.adminDashboard.addingDataLoading}
                                                                        dashboardData={{...this.props.adminDashboard.data, patients: this.currentDentist.patients}}
                                                                        toggleSubcaseFormModal={this.handleChangeParentId}
                                                                        getData={this.props.getData}
                                                                        isOpenSubcaseForm={this.state.isOpenSubcaseForm}
                                                                        addPatient={this.props.addPatient}
                                                                        addDentist={this.props.addDentist}
                                                                        addBooking={this.props.addBooking}
                                                                        getCaseDetails={this.props.getCaseDetails}
                                                                        minDateForSubcase={this.props.adminCaseDetails.caseList.minDateForSubcase}
                                                                        vacationDays={this.props.vacationDays}
                                                                        bridges={this.state.patient.bridges}
                                                                        checkedTeeth={this.state.checkedTeeth}
                                                                        makeBridge={(from,to)=>this.makeBridge(from,to)}
                                                                    />
                                                                    : ''
                                                            }
                                                            <div className="date">
                                                                <div className="date__today todays-date">
                                                                    <div
                                                                        className="text-field date__field"
                                                                    >
                                                                        <label className="text-field__label" htmlFor="">Date</label>
                                                                        <input
                                                                            type="text"
                                                                            className="text-field__input"
                                                                            placeholder="Date Of Submittion"
                                                                            disabled={true}
                                                                            value={moment(this.state.patient.dateOfSubmission).format("DD/MM/YYYY")}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="date__other date__field">
                                                                    <div className="date__return return-date" check={true} inline="true">
                                                                        <div
                                                                            className={(this.state.validationBooking.returnDate) ? "react-calendar has-error" : "react-calendar"}
                                                                        >
                                                                            <label className='react-calendar__label'>Return Date <span className="asterisk">*</span></label>
                                                                            <div className="react-calendar__field">
                                                                                <span className="kr kr-calendar" />
                                                                                <DatePicker
                                                                                    dayClassName={date => isNonWorkingDay(date,this.props.vacationDays) ? 'disabled_date' : ''}
                                                                                    placeholderText={"Select return date"}
                                                                                    //minDate={this.props.adminCaseDetails.caseList && this.props.adminCaseDetails.caseList.minDateForSubcase ? moment(this.props.adminCaseDetails.caseList.minDateForSubcase) : null}
                                                                                    className={`datePickerInput custom-input ${inputClassname}`}
                                                                                    dateFormat="DD/MM/YYYY"
                                                                                    disabled={disabled}
                                                                                    selected={this.state.patient.dateOfReturn ? moment(this.state.patient.dateOfReturn) : null}
                                                                                    onChange={this.handleDateChange}/>
                                                                                {this.state.validationBooking.returnDate &&
                                                                                    <span className="error-message">Return Date field is required.</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="date__sending sending-date">
                                                                        <div
                                                                            className={(this.state.validationBooking.sendingDate) ? "react-calendar has-error" : "react-calendar"}
                                                                        >
                                                                            <label className='react-calendar__label'>Sending Date <span className="asterisk">*</span></label>
                                                                            <div className="react-calendar__field" data-for="sendingDate" data-tip="Please select Return Date first.">
                                                                                <span className="kr kr-calendar" />
                                                                                <DatePicker
                                                                                    dayClassName={date => isNonWorkingDay(date,this.props.vacationDays) ? 'disabled_date' : ''}
                                                                                    className={`datePickerInput custom-input ${sendingDateClassname}`}
                                                                                    disabled={isSendingDateDisabled}
                                                                                    selected={this.state.patient.sendingDate ? moment(this.state.patient.sendingDate) : null}
                                                                                    onChange={(sendingDate) => this.handleChangeSendingDate(sendingDate)}
                                                                                    placeholderText={"Select sending date"}
                                                                                    dateFormat="DD/MM/YYYY"
                                                                                    //minDate={this.props.adminCaseDetails.caseList && this.props.adminCaseDetails.caseList.caseDetails && this.props.adminCaseDetails.caseList.caseDetails.parent_id ? moment(this.props.adminCaseDetails.caseList.minDateForSubcase).subtract(12, 'days') : null}
                                                                                    //maxDate={moment(this.state.patient.dateOfReturn)}
                                                                                />
                                                                                {this.state.validationBooking.sendingDate &&
                                                                                    <span className="error-message">Sending Date field is required.</span>}
                                                                                {!this.state.patient.dateOfReturn && !this.state.patient.sendingDate &&
                                                                                    <ReactTooltip place="top" id="sendingDate" type="light" effect="float"/>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="dentist">
                                                                <p>
                                                                    <span className="dr-label">Doctor</span>
                                                                    <span className="dr-name">{this.state.dentistName}</span>
                                                                </p>
                                                            </div>

                                                            <div className="patient">
                                                                <div className={
                                                                    this.state.validationBooking.patientId ? "patient__block has-error" : "patient__block"}
                                                                >
                                                                    <label className="patient__label">Patient <span className="asterisk">*</span></label>
                                                                    <div className="patient__select select">
                                                                        <Input type="select"
                                                                               disabled={disabled || overdue || rejected || disabledOnhold || received}
                                                                               value={this.state.patient.patientId}
                                                                               onChange={(e) => this.handleChange('patientId', e.target.value)}
                                                                               className={`booking-select form-control Select-control custom-input ${readyDisabled} ${disabledOverReject}`}>
                                                                            {
                                                                                this.dentistList.map((dentist, index) => {
                                                                                        if(this.props.adminCaseDetails.caseList.dentistId === dentist.id){
                                                                                            return (
                                                                                                <optgroup key={index}
                                                                                                          label={dentist.first_name + ' ' + dentist.last_name}>
                                                                                                    {
                                                                                                        dentist.patients.map((patient, index) =>
                                                                                                            <option key={index}
                                                                                                                    value={patient.id}> {patient.first_name + ' ' + patient.last_name}</option>
                                                                                                        )
                                                                                                    }
                                                                                                </optgroup> )
                                                                                        }

                                                                                    }
                                                                                )
                                                                            }
                                                                        </Input>
                                                                        {this.state.validationBooking.patientId &&
                                                                            <span className="error-message">Patient field is required.</span>}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="type">
                                                                <div className={(this.state.validationBooking.type) ? "type__block has-error" : "type__block"}>
                                                                    <label className='type__label'>Type <span className="asterisk">*</span></label>
                                                                    <div className="type__select">
                                                                        <Select name="types"
                                                                                disabled={disabled}
                                                                                className='booking-select   select-box' /*add -select-box- classname*/
                                                                                placeholder="Select Type"
                                                                                style={{
                                                                                    boxShadow: 'none',
                                                                                    fontSize: '16px',
                                                                                }}
                                                                                matchPos="start"
                                                                                value={this.state.patient.type}
                                                                                onChange={(selectedOption) => this.handleChange('type', selectedOption ? selectedOption.value : selectedOption)}
                                                                                options={[
                                                                                    {label: 'Prototype', value: 'prototype'},
                                                                                    {label: 'Zirconia', value: 'zirconia'},
                                                                                    {label: 'Temp', value: 'temp'},
                                                                                    {label: 'Other', value: 'other'},
                                                                                    {label: 'Ceramic', value: 'ceramic'}
                                                                                ]}
                                                                        />
                                                                    </div>
                                                                    {this.state.validationBooking.type &&
                                                                        <span className="error-message">Type is required.</span>}
                                                                </div>
                                                            </div>

                                                            <div className="total-units">
                                                                <div className="total-units__block">
                                                                    <div
                                                                        className={(this.state.validationBooking.numberOfUnits) || (this.state.numberOfUnits < 0) ? "text-field has-error" : "text-field"}
                                                                    >
                                                                        <label className="text-field__label" htmlFor="">Total no. of units <span className="asterisk">*</span></label>
                                                                        <input
                                                                            className="text-field__input"
                                                                            type="number"
                                                                            value={this.state.patient.numberOfUnits}
                                                                            placeholder="0"
                                                                            disabled={disabled}
                                                                            onChange={(e) => this.handleChange('numberOfUnits', e.target.value)}
                                                                        />
                                                                        {(this.state.validationBooking.numberOfUnits) ? (this.state.numberOfUnits < 0) ?
                                                                            <span className="error-message">Please enter a valid number.</span> :
                                                                            <span className="error-message">Number of units field is required.</span> : ''}
                                                                    </div>
                                                                    <div className="units__available">
                                                                        <div>
                                                                            Available units:
                                                                            {` Zirc/Cer: ${this.state.availableUnits && this.state.availableUnits.zirconia}
                                         Misc: ${this.state.availableUnits && this.state.availableUnits.misc}`}
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                <div className="total-units__block">
                                                                    <div className="implant">
                                                                        <label className="implant__label">Implant <span className="asterisk">*</span></label>
                                                                        <div className="implant__radio">
                                                                            <div check={true} className="radio-button custom-control custom-radio">
                                                                                <input
                                                                                    className="custom-control-input"
                                                                                    value={1}
                                                                                    id="implant-4"
                                                                                    disabled={disabled}
                                                                                    onChange={(e) => this.handleChange('implant', e.target.value)}
                                                                                    type="radio"
                                                                                    checked={this.state.patient.implant === '1' ? true : false}
                                                                                    name="implant3"
                                                                                />
                                                                                <label className="custom-control-label" htmlFor="cr-sub-implant-0">
                                                                                    Yes
                                                                                </label>
                                                                            </div>
                                                                            <div check={true} className="radio-button custom-control custom-radio">
                                                                                <input
                                                                                    className="custom-control-input"
                                                                                    value={0}
                                                                                    id="implant-5"
                                                                                    disabled={disabled}
                                                                                    onChange={(e) => this.handleChange('implant', e.target.value)}
                                                                                    type="radio"
                                                                                    checked={this.state.patient.implant === '0' ? true : false}
                                                                                    name="implant3"
                                                                                />
                                                                                <label className="custom-control-label" htmlFor="cr-sub-implant-1">
                                                                                    No
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {this.state.validationBooking.implant && <span className="error-message">Implant must be yes or no.</span>}
                                                                </div>
                                                            </div>

                                                            <div className="upload">
                                                                <Images handleChange={(key, value,isDirty) => this.handleChange(key, value,"",isDirty)}
                                                                        buttonDisabled={patient.isArchived}
                                                                        onImageChange={() => this.setState({ isDirty: true, buttonDisabled: false })}
                                                                        disabledEdit={patient.isArchived}
                                                                        handleSeeMore={() => this.handleSeeMore()}
                                                                        hasErrorImages={this.state.hasErrorImages}
                                                                        images={this.state.patient.images}
                                                                        removeImage={(name) => this.removeImage(name)}
                                                                        isForm={true}
                                                                        status={this.state.patient.status}
                                                                        dentistId={this.props.adminCaseDetails.caseList.dentistId}
                                                                        caseId={this.state.caseId}
                                                                />
                                                            </div>

                                                            <div>
                                                                {this.props.adminCaseDetails.caseList.history && this.props.adminCaseDetails.caseList.history.length > 0 ?
                                                                    <HistoryWrapper  caseId={this.state.caseId} /> : ''}
                                                            </div>
                                                        </div>
                                                        <div className="book__block">
                                                            <div className="add-info-title">
                                                                <h6>Additional information</h6>
                                                            </div>
                                                            <div className="color">
                                                                <div
                                                                    className="text-field"
                                                                >
                                                                    <label className="text-field__label" htmlFor="">Color</label>
                                                                    <input
                                                                        className="text-field__input"
                                                                        disabled={disabled || rejected}
                                                                        onChange={(e) => this.handleChange('color', e.target.value)}
                                                                        value={this.state.patient.color}
                                                                        type="text"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="cases-notes">
                                                                <div
                                                                    className="text-field textarea"
                                                                >
                                                                    <label className="text-field__label" htmlFor="">Case notes</label>
                                                                    <div className={`textarea__block ${ patient.isArchived ? 'textarea__block__disabled' : '' } ${this.state.isTextareaFocused ? 'textarea__block--focused' : ''}`}>
                            <textarea
                                className="text-field__input"
                                disabled={patient.isArchived}
                                onChange={(e) => this.handleChange('notes', e.target.value)}
                                value={this.state.patient.notes}
                                rows={3}
                            />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="admin-notes">
                                                                <div
                                                                    className="text-field textarea"
                                                                >
                                                                    <label className="text-field__label" htmlFor="">Notes for Lab Admin</label>
                                                                    <div
                                                                        className={`textarea__block ${this.state.isTextareaFocusedForAdmin ? 'textarea__block--focused' : ''}`}>
                                <textarea
                                    className="text-field__input"
                                    onChange={(e) => this.handleChange('admin_case_notes', e.target.value)}
                                    value={this.state.patient.admin_case_notes}
                                    rows={3}
                                />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="signature">
                                                                <div
                                                                    className="text-field"
                                                                >
                                                                    <label className="text-field__label" htmlFor="">Signature</label>
                                                                    <input
                                                                        className="text-field__input"
                                                                        disabled={isSignatureAndLicenseDisabled}
                                                                        onChange={(e) => this.handleChange('signature', e.target.value)}
                                                                        value={this.state.patient.signature} type="text"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="license">
                                                                <div
                                                                    className="text-field"
                                                                >
                                                                    <label className="text-field__label" htmlFor="">License</label>
                                                                    <input
                                                                        className="text-field__input"
                                                                        disabled={isSignatureAndLicenseDisabled}
                                                                        onChange={(e) => this.handleChange('license', e.target.value)}
                                                                        value={this.state.patient.license}
                                                                        type="text"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="book__block">
                                                            <div className="enclosed">
                                                                <h6 className="enclosed__title">Enclosed in the box <span className="asterisk">*</span></h6>
                                                                {
                                                                    Object.keys(this.state.enclosedBoxObject).map((value, index) => {
                                                                        let find = this.state.patient.enclosedBox.find(item => {
                                                                            return (item === parseInt(value, 10))
                                                                        })
                                                                        return (
                                                                            <div key={index} className="enclosed__list">
                                                                                <div check={true} className="checkbox custom-control custom-checkbox">
                                                                                    <input
                                                                                        id={this.state.enclosedBoxObject[value].name.replace(/\s|\//g, '_')}
                                                                                        type="checkbox"
                                                                                        className="custom-control-input"
                                                                                        name="type"
                                                                                        value={value}
                                                                                        onChange={(e) => this.handleChange('enclosedBox', parseInt(e.target.value, 10))}
                                                                                        disabled={disabled || rejected || overdue || disabledOnhold}
                                                                                        checked={find !== undefined ? true : false}
                                                                                    />
                                                                                    <label
                                                                                        htmlFor={this.state.enclosedBoxObject[value].name.replace(/\s|\//g, '_')}
                                                                                        className="checkbox-label custom-control-label"
                                                                                    >
                                                                                        {this.state.enclosedBoxObject[value].name}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                                {this.state.validationBooking.enclosedBox && <FormText>Choose at least one of the above.</FormText>}
                                                            </div>
                                                            {this.state.patient.implant === '1' && <Fragment>
                                                                <div className="implant-block">
                                                                    <div
                                                                        className="text-field"
                                                                    >
                                                                        <label className="text-field__label" htmlFor="">Implant Type</label>
                                                                        <input
                                                                            className="text-field__input"
                                                                            disabled={disabled || overdue || rejected}
                                                                            onChange={(e) => this.handleChange('implantType', e.target.value)}
                                                                            value={this.state.patient.implantType}
                                                                            type="text"
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        className="text-field"
                                                                    >
                                                                        <label className="text-field__label" htmlFor="">Implant Size</label>
                                                                        <input
                                                                            className="text-field__input"
                                                                            disabled={disabled || overdue || rejected}
                                                                            value={this.state.patient.implantSize}
                                                                            onChange={(e) => this.handleChange('implantSize', e.target.value)}
                                                                            type="text"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="parts">
                                                                    <h6 className="parts__title">Implant Parts:</h6>
                                                                    {
                                                                        Object.keys(this.state.implantsPartObject).map((value, index) => {
                                                                            let find = Object.keys(this.state.patient.implantParts).find(item => {
                                                                                return (item === value)
                                                                            })
                                                                            return (
                                                                                <div key={index} className="parts__list">
                                                                                    <div check={true}
                                                                                         className="checkbox custom-control custom-checkbox">
                                                                                        <input
                                                                                            id={this.state.implantsPartObject[value].name.replace(/\s|\//g, '__')}
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            name="type"
                                                                                            value={value}
                                                                                            onChange={(e) => this.handleChange('implantParts', e.target.value)}
                                                                                            disabled={disabled}
                                                                                            checked={this.state.patient.implantParts[value] !== undefined ? true : false}
                                                                                        />
                                                                                        <label
                                                                                            htmlFor={this.state.implantsPartObject[value].name.replace(/\s|\//g, '__')}
                                                                                            className="checkbox-label custom-control-label"
                                                                                        >
                                                                                            {this.state.implantsPartObject[value].name}
                                                                                        </label>
                                                                                    </div>
                                                                                    {(find !== undefined) ?
                                                                                        <div
                                                                                            className="text-field"
                                                                                        >
                                                                                            <input
                                                                                                className="text-field__input"
                                                                                                disabled={disabled}
                                                                                                value={this.state.patient.implantParts[find]}
                                                                                                type="number"
                                                                                                onChange={(e) => this.handleChange('implantParts', e.target.value, find)}
                                                                                            />
                                                                                        </div> : ''}
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </Fragment>}
                                                        </div>
                                                    </div>
                                                    <div className="print-bridge" ref={this.bridgesRef}>
                                                        <div className="print-bridge__container">
                                                            <div className="print-bridge__block">
                                                                <div className='t-left'>
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.top.left).map((key)=>{
                                                                            return <Fragment>
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.top.left[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.top.left[key].number,this.state.bridgesStructure.top.left[key].number)}>
                                                                                    {this.state.bridgesStructure.top.left[key].number}
                                                                                </div>
                                                                                {this.state.bridgesStructure.top.left[key].number !== 18 && <span
                                                                                    className={
                                                                                        `${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.top.left[key].number && item.to === this.state.bridgesStructure.top.left[key].number+1) && 'checked_bridge'}
                                                     bottom-bridge ${this.state.patient.bridges && this.state.patient.bridges.map((item)=>{if(item.from ===this.state.bridgesStructure.top.left[key].number && item.to === this.state.bridgesStructure.top.left[key].number+1){ return 'checked_bridge'}})}
                                                     ${'bottom-bridge-' + this.state.bridgesStructure.top.left[key].number + '-' + parseFloat(this.state.bridgesStructure.top.left[key].number + 1)}`}
                                                                                    onClick={() => this.makeBridge(this.state.bridgesStructure.top.left[key].number, this.state.bridgesStructure.top.left[key].number + 1)}
                                                                                >
                                            </span>}
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                </div>
                                                                <div className="t-center">
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.top.center).map((key)=>{
                                                                            return <Fragment>
                                                                                {
                                                                                    this.state.bridgesStructure.top.center[key].number === 12 &&
                                                                                    <span
                                                                                        className={`
                                                    ${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.top.center[key].number && item.to === this.state.bridgesStructure.top.center[key].number+1) && 'checked_bridge'}
                                                    ${this.state.bridgesStructure.top.center[key].number === 12 && 'left-bridge'} right-bridge ${'right-bridge-'+this.state.bridgesStructure.top.center[key].number+'-'+parseFloat(this.state.bridgesStructure.top.center[key].number + 1)}`}
                                                                                        onClick={()=>this.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number+1)}
                                                                                    />
                                                                                }
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.top.center[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number)}>
                                                                                    {this.state.bridgesStructure.top.center[key].number}
                                                                                </div>
                                                                                <span
                                                                                    className={`
                                                                                    ${this.state.patient.bridges && this.state.patient.bridges.some(item => this.state.bridgesStructure.top.center[key].number === 11 ? item.from === 11 && item.to === 21 : item.from === this.state.bridgesStructure.top.center[key].number && item.to === this.state.bridgesStructure.top.center[key].number+1 && item.to !== 13) && 'checked_bridge'}
                                                                                    ${this.state.patient.bridges && this.state.patient.bridges.some(item => this.state.bridgesStructure.top.center[key].number === 11 ? item.from === 11 && item.to === 21 : item.from === this.state.bridgesStructure.top.center[key].number && item.to === this.state.bridgesStructure.top.center[key].number+1 || this.state.bridgesStructure.top.center[key].number === 12 ? item.from === 12 && item.to === 11 : null) && 'checked_bridge'}
                                                                                    ${this.state.bridgesStructure.top.center[key].number === 12 && 'left-bridge'} right-bridge ${'right-bridge-'+this.state.bridgesStructure.top.center[key].number+'-'+parseFloat(this.state.bridgesStructure.top.center[key].number + 1)}`}
                                                                                    onClick={()=>this.state.bridgesStructure.top.center[key].number === 12 ? this.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number-1) : this.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number+1)}
                                                                                />
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                    <div className="u-title">Upper Jaw</div>
                                                                </div>
                                                                <div className="t-right">
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.top.right).map((key)=>{
                                                                            return <Fragment>
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.top.right[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.top.right[key].number,this.state.bridgesStructure.top.right[key].number)}>
                                                                                    {this.state.bridgesStructure.top.right[key].number}
                                                                                </div>
                                                                                {this.state.bridgesStructure.top.right[key].number !== 28 && <span
                                                                                    className={`
                                                    ${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.top.right[key].number && item.to === this.state.bridgesStructure.top.right[key].number+1) && 'checked_bridge'}
                                                    bottom-bridge ${'bottom-bridge-' + this.state.bridgesStructure.top.right[key].number + '-' + parseFloat(this.state.bridgesStructure.top.right[key].number + 1)}`}
                                                                                    onClick={() => this.makeBridge(this.state.bridgesStructure.top.right[key].number, this.state.bridgesStructure.top.right[key].number + 1)}
                                                                                >
                                            </span>}
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="print-bridge__block">
                                                                <div className='t-left'>
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.bottom.left).map((key)=>{
                                                                            return <Fragment>
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.bottom.left[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.bottom.left[key].number,this.state.bridgesStructure.bottom.left[key].number)}>
                                                                                    {this.state.bridgesStructure.bottom.left[key].number}
                                                                                </div>
                                                                                {this.state.bridgesStructure.bottom.left[key].number !== 43 && <span
                                                                                    className={`${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.bottom.left[key].number-1 && item.to === this.state.bridgesStructure.bottom.left[key].number) && 'checked_bridge'}
                                                bottom-bridge ${'bottom-bridge-' + this.state.bridgesStructure.bottom.left[key].number + '-' + parseFloat(this.state.bridgesStructure.bottom.left[key].number + 1)}`}
                                                                                    onClick={() => this.makeBridge(this.state.bridgesStructure.bottom.left[key].number-1, this.state.bridgesStructure.bottom.left[key].number)}
                                                                                >
                                            </span>}
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                </div>
                                                                <div className="t-center">
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.bottom.center).map((key)=>{
                                                                            return <Fragment>
                                                                                {
                                                                                    this.state.bridgesStructure.bottom.center[key].number === 42 &&
                                                                                    <span
                                                                                        className={`${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.bottom.center[key].number && item.to === this.state.bridgesStructure.bottom.center[key].number+1) && 'checked_bridge'}
                                                    ${this.state.bridgesStructure.bottom.center[key].number === 42 && 'left-bridge'} right-bridge ${'right-bridge-'+this.state.bridgesStructure.bottom.center[key].number+'-'+parseFloat(this.state.bridgesStructure.bottom.center[key].number + 1)}`}
                                                                                        onClick={()=>this.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number+1)}
                                                                                    ></span>
                                                                                }
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.bottom.center[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number)}>
                                                                                    {this.state.bridgesStructure.bottom.center[key].number}
                                                                                </div>
                                                                                <span
                                                                                    className={`${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.bottom.center[key].number && item.to === this.state.bridgesStructure.bottom.center[key].number+1) && this.state.bridgesStructure.bottom.center[key].number !== 42 && 'checked_bridge'}
                                                ${this.state.patient.bridges && this.state.patient.bridges.some(item => this.state.bridgesStructure.bottom.center[key].number === 41 ? item.from === 41 && item.to === 31 : item.from === this.state.bridgesStructure.bottom.center[key].number && item.to === this.state.bridgesStructure.bottom.center[key].number+1 || this.state.bridgesStructure.bottom.center[key].number === 42 ? item.from === 42 && item.to === 41 : null) && 'checked_bridge'}
                                                 right-bridge ${'right-bridge-'+this.state.bridgesStructure.bottom.center[key].number+'-'+parseFloat(this.state.bridgesStructure.bottom.center[key].number + 1)}`}
                                                                                    onClick={()=>this.state.bridgesStructure.bottom.center[key].number === 42 ? this.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number-1) : this.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number+1)}
                                                                                >
                                            </span>
                                                                            </Fragment>
                                                                        })
                                                                    }
                                                                    <div className="l-title">Lower Jaw</div>
                                                                </div>
                                                                <div className="t-right">
                                                                    {
                                                                        Object.keys(this.state.bridgesStructure.bottom.right).map((key)=>{
                                                                            return <Fragment>
                                                                                <div className={`t-item ${this.state.checkedTeeth.includes(this.state.bridgesStructure.bottom.right[key].number) ? 'checked' : ''}`} onClick={()=>this.makeBridge(this.state.bridgesStructure.bottom.right[key].number,this.state.bridgesStructure.bottom.right[key].number)}>
                                                                                    {this.state.bridgesStructure.bottom.right[key].number}
                                                                                </div>
                                                                                {this.state.bridgesStructure.bottom.right[key].number !== 33 && <span
                                                                                    className={`${this.state.patient.bridges && this.state.patient.bridges.some(item => item.from === this.state.bridgesStructure.bottom.right[key].number && item.to === this.state.bridgesStructure.bottom.right[key].number-1) && 'checked_bridge'}
                                                bottom-bridge ${'bottom-bridge-' + this.state.bridgesStructure.bottom.right[key].number + '-' + parseFloat(this.state.bridgesStructure.bottom.right[key].number + 1)}`}
                                                                                    onClick={() => this.makeBridge(this.state.bridgesStructure.bottom.right[key].number, this.state.bridgesStructure.bottom.right[key].number-1)}
                                                                                >
                                            </span>}
                                                                            </Fragment>

                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="details-actions">
                                                            <div>
                                                                <button
                                                                    className="btn btn-outline"
                                                                    onClick={this.cancelEdits}>
                                                                    Cancel
                                                                </button>
                                                                <button
                                                                    className="btn btn-primary"
                                                                    disabled={this.state.isDirty || this.state.patient.status === 'pending' ? false : this.state.buttonDisabled || this.props.adminCaseDetails.editingDataLoading}
                                                                    onClick={(event) => this.handleSaveBooking(event)}>
                                                                    {(this.state.patient.status === 'pending')
                                                                        ? 'Confirm'
                                                                        : 'Save'}
                                                                </button>
                                                            </div>
                                                    </div>
                                                </form>
                                        }
                                    </div>}
                                    <ViewForPrinting
                                        ref={el => (this.componentRef = el)}
                                        implantsPartObject={this.state.implantsPartObject}
                                        enclosedBoxObject={this.state.enclosedBoxObject}
                                        patient={this.state.patient}
                                        patientName={this.state.patientName}
                                        dentistName={this.state.dentistName}
                                        isAdmin={true}
                                    />
                                    {
                                        this.state.showEditModal &&
                                        <ModalComponent
                                            modalHeaderStyle="modalHeaderDefault"
                                            headerTitle={this.state.modalHeader}
                                            modalBody={this.state.modalBody}
                                            show={this.state.showEditModal}
                                            handleClose={() => this.handleClose()}
                                            buttonText="Yes"
                                            buttonDisabled={this.state.patient.status === 'pending' ? false : this.state.buttonDisabled || this.props.adminCaseDetails.editingDataLoading}
                                            buttonFunction={(event) => this.handleSaveBooking(event)}
                                        />
                                    }
                                    {
                                        this.state.cancelCaseModal &&
                                        <ModalComponent
                                            modalHeaderStyle="modalHeaderDefault"
                                            headerTitle="Delete Case"
                                            modalBody="Are you sure you want to cancel the booking?"
                                            show={this.state.cancelCaseModal}
                                            handleClose={() => this.handleClose()}
                                            buttonText="Delete"
                                            buttonFunction={() => this.cancelBooking(this.state.caseId)}
                                        />
                                    }
                                    {
                                        this.state.isOpenConvertModal &&
                                        <ModalComponent
                                            modalHeaderStyle="modalHeaderDefault"
                                            headerTitle={this.props.adminCaseDetails.caseList &&
                                            this.props.adminCaseDetails.caseList.caseDetails &&
                                            this.props.adminCaseDetails.caseList.caseDetails.parent_id
                                                ? "Convert Subcase" : "Convert Case"}
                                            modalBody={this.props.adminCaseDetails.caseList &&
                                            this.props.adminCaseDetails.caseList.caseDetails &&
                                            this.props.adminCaseDetails.caseList.caseDetails.parent_id ?
                                                "Are you sure you want to convert Subcase to Case?"
                                                :
                                                <SubcaseModalBody
                                                    isConvertModal={true}
                                                    toggleSubcaseFormModal={this.handleChangeParentId}
                                                    eventList={this.eventList.filter(item => item.caseId.toString() !== this.state.caseId)}
                                                    parentId={this.state.parentId}
                                                />}
                                            show={this.state.isOpenConvertModal}
                                            handleClose={() => this.handleClose()}
                                            buttonText="Convert"
                                            buttonFunction={() => this.convertCase()}
                                        />
                                    }
                                    {
                                        this.state.printModal &&
                                        <ModalComponent
                                            modalHeaderStyle="modalHeaderDefault"
                                            headerTitle="Print Booking"
                                            modalBody={"Would you like to print the case?"}
                                            printCase={this.state.printModal}
                                            show={this.state.printModal}
                                            caseDetails={this.props.adminDashboard.data}
                                            handleClose={this.togglePrintModal}
                                            buttonText="Yes"
                                            isAdmin={false}
                                        />
                                    }
                                    {
                                        this.state.isOpenProceedModal &&
                                        <ModalComponent
                                            modalHeaderStyle="modalHeaderDefault"
                                            headerTitle="Convert To Subcase"
                                            modalBody={"In case you proceed the dentist and patient may be changed as well. Are you sure you want to proceed?"}
                                            show={this.state.isOpenProceedModal}
                                            handleClose={() => this.handleClose()}
                                            buttonText="Yes"
                                            isPickupModal={true}
                                            buttonFunction={() => this.convertCase()}
                                        />
                                    }
                                    {
                                        this.state.changeStatusModal &&
                                        <ModalComponent
                                            modalHeaderStyle={this.state.modalHeaderType}
                                            headerTitle={this.state.modalHeaderText}
                                            modalBody={this.state.modalBodyText}
                                            show={this.state.changeStatusModal}
                                            handleClose={() => this.handleClose()}
                                            buttonText="Yes"
                                            buttonFunction={(event) => this.onChangeStatus(event, this.state.caseStatus, this.state.patient.status === ON_HOLD)}
                                        />
                                    }

                                </div>
                            </div>
                        </div>
                    </Fragment>}
                <RouteLeavingGuard
                    when={this.state.isDirty}
                    shouldBlockNavigation={this.state.isDirty}
                    approvable={false}
                    navigate={path => {
                        this.setState({ isDirty: false }, () => this.props.history.push(path))
                    }}
                    saveChanges={(event) => this.handleSaveBooking(event,false)}
                />
            </div>
        )
    }
}

const mapStateToProps = dispatch => {
    return {
        imageUpload: dispatch.imageUploadReducer,
        vacationDays: dispatch.adminDashboard.vacationDays,
        bridges: dispatch.adminCaseDetails.caseList.bridges,
        adminCaseDetails: dispatch.adminCaseDetails,
        adminDashboard: dispatch.adminDashboard
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAvailableUnitsList: (date) => {
            dispatch(getAvailableUnitsList(date));
        },
        changeCaseStatus: (data) => dispatch(changeCaseStatus(data)),
        editCase: (data) => {
            dispatch(editCase(data));
        },
        editAdminCaseNotes: (data) => {
            dispatch(editAdminCaseNotes(data))
        },
        getCase: (caseId) => {
            dispatch(getCase(caseId));
        },
        cancelCase: (data) => {
            dispatch(cancelCase(data));
        },
        getAvailableUnits: (data) => {
            dispatch(getAvailableUnits(data));
        },
        getData: () => dispatch(getData()),
        addDentist: (data) => {
            dispatch(addDentist(data));
        },
        addPatient: (data) => {
            dispatch(addPatient(data));
        },
        addBooking: (data) => {
            dispatch(addBooking(data));
        },
        getCaseDetails: (caseId) => {
            dispatch(getCaseDetails(caseId));
        },
        convertCase: (data) => {
            dispatch(convertCase(data));
        },
        getParentCases: () => {
            dispatch(getParentCases());
        },
        getVacationDays: () => {
            dispatch(getVacationDaysRequest());
        },
        startImageUploading: (data) => {
            dispatch(startImageUploading(data))
        },
        removeAllUploads: () => {
            dispatch(removeAllImageUploads());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminCaseDetails);



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AdminCaseDetails/index.js